module.exports = __webpack_public_path__ + "img/smartTutoring2PC.eb8d2da6.png";